import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=3ecf700f&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf700f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ecf700f')) {
      api.createRecord('3ecf700f', component.options)
    } else {
      api.reload('3ecf700f', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=3ecf700f&scoped=true&", function () {
      api.rerender('3ecf700f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23W9Ka7D4pcPK/JS/comp/Accordion.vue"
export default component.exports